import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form, Input, Button } from 'antd';
import { Link } from 'react-router-dom';
import cw from '../../utils/commonwords';
import ResetCheck from '../../images/reset-check.svg';
import {
  forgotPassword,
  resetForgotPasswordTokenRequestSuccess
} from '../../store/auth/actions';
import { SSO_URL } from '../../config/environment';
const FormItem = Form.Item;

class ForgottenPassword extends Component {
  state = {
    authType: 'msisdn'
  };
  componentWillUnmount = () => {
    this.props.resetForgotPasswordTokenRequestSuccess();
  };
  asyncEmail = (rule, value, callback) => {
    if (!value) {
      callback();
    }
    if (value) {
      this.setState({ authType: 'email' });
      return fetch(`${SSO_URL}/auths/users?email=${value}`, {
        headers: new Headers({
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
        })
      }).then(response => response.json()).then(json => {
        if (json.statusCode === 204) {
          callback(this.props.intl.formatMessage(cw['ValueDoesNotExist'], { value }));
        }
      }).catch(error => {
        callback(this.props.intl.formatMessage(cw['InvalidEmail']));
      });
    }
    callback();
  };

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.forgotPassword(
          values.email.trim(),
          this.props.siteLanguage,
          this.props.intl,
          this.state.authType
        );
      }
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      forgot_password_token_request_success,
      intl
    } = this.props;
    if (forgot_password_token_request_success) {
      return (
        <React.Fragment>
          <div style={{ textAlign: 'center' }}>
            <div style={{ marginBottom: 19 }}>
              <img src={ResetCheck} alt="envelope" width="75" />
            </div>
            <p
              style={{
                fontSize: '24px',
                color: '#595959'
              }}
            >
              {' '}
              <FormattedMessage
                defaultMessage="Your password reset request has been made!!"
                id="App.Text.PasswordResetMade"
              />
            </p>
            <p
              style={{
                color: '#8C8C8C'
              }}
            >
              <FormattedMessage
                defaultMessage={`Reset token been sent to your phone. Please use it to complete the process.`}
                id="App.Text.ResetPasswordEmailInfo"
              />
            </p>
          </div>
          <div className="auth_form_links" style={{ textAlign: 'center' }}>
            <p style={{ paddingTop: '10%' }}>
              <FormattedMessage
                id="resetPassword.loginPageLink"
                defaultMessage={'Return to sign in page'}
              />{' '}
              <Link
                data-dfs-people-id={'signin-link'}
                to={`/${this.props.siteLanguage || 'en'}/signin`}
              >
                <FormattedMessage
                  id="App.Text.Signin"
                  defaultMessage={'Sign in'}
                />
              </Link>
            </p>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <Form onSubmit={this.handleSubmit} className="auth_form">
          <h2 className="auth_form_title">
            <FormattedMessage
              defaultMessage="Reset Password"
              id="App.Text.ResetPassword"
            />
          </h2>

          <p className="auth_form_description">
            <FormattedMessage
              defaultMessage="Fill in your username below and we will send you further instructions on resetting your password."
              id="App.resetPassword.description"
            />
          </p>
          <FormItem
            colon={false}
            label={
              <FormattedMessage
                id="loginForm.EmailAddressInput"
                defaultMessage={'Email'}
              />
            }
          >
            {getFieldDecorator('email', {
              validate: [
                {
                  trigger: 'onBlur',
                  rules: [{ validator: this.asyncEmail }]
                },
                {
                  trigger: 'onChange',
                  rules: [
                    {
                      required: true,
                      message: intl.formatMessage(
                        cw.formErrorMsgInputEmail
                      )
                    }
                  ]
                }
              ]
            })(
              <Input
                size="large"
                data-dfs-people-id={'email-input'}
                placeholder="Email"
              />
            )}
          </FormItem>

          <div className="loginForm__Btn">
            <Button
              size="large"
              data-dfs-people-id={'forgot-password-button'}
              block
              type="primary"
              htmlType="submit"
              className="login-form-button"
              loading={this.props.forgot_password_token_requesting}
              disabled={this.props.forgot_password_token_requesting}
            >
              <FormattedMessage
                id="App.Text.ResetPassword"
                defaultMessage={'Reset Password'}
              />
            </Button>
          </div>

          <div className="auth_form_links">
            <p style={{ paddingTop: '10%' }}>
              <FormattedMessage
                id="loginScreen.HaveAccountText"
                defaultMessage={'Already have an account?'}
              />{' '}
              <Link
                data-dfs-people-id={'signin-link'}
                to={`/${this.props.siteLanguage || 'en'}/signin`}
              >
                <FormattedMessage
                  id="App.Text.Signin"
                  defaultMessage={'Sign in'}
                />
              </Link>
            </p>
          </div>
        </Form>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    siteLanguage: state.intl.siteLanguage,
    forgot_password_token_requesting:
      state.auth.forgot_password_token_requesting,
    forgot_password_token_request_msg:
      state.auth.forgot_password_token_request_msg,
    auth_type: state.auth.auth_type,
    forgot_password_token_request_success:
      state.auth.forgot_password_token_request_success
  };
};

const mapDispatchToProps = dispatch => {
  return {
    forgotPassword: (email, lang, intl, authType) => {
      dispatch(forgotPassword(email, lang, intl, authType));
    },
    resetForgotPasswordTokenRequestSuccess: () => {
      dispatch(resetForgotPasswordTokenRequestSuccess());
    }
  };
};

const ForgottenPasswordForm = Form.create()(ForgottenPassword);

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ForgottenPasswordForm)
);
